import { render } from "./ViewWrapper.vue?vue&type=template&id=edfff5a4&scoped=true"
import script from "./ViewWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewWrapper.vue?vue&type=script&setup=true&lang=js"

import "./ViewWrapper.vue?vue&type=style&index=0&id=edfff5a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edfff5a4"],['__file',"src/components/ViewWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "edfff5a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('edfff5a4', __exports__)) {
    api.reload('edfff5a4', __exports__)
  }
  
  module.hot.accept("./ViewWrapper.vue?vue&type=template&id=edfff5a4&scoped=true", () => {
    api.rerender('edfff5a4', render)
  })

}


export default __exports__